/**
 * Warm the rooms cache as soon as the visitor has entered the site.
 *
 * The rooms list and the floorplan SVGs are client-only fetches, which made /rooms and
 * /rooms/[slug] show an empty floorplan until they resolved. Fetching them on idle right
 * after the first page is interactive means the data is already in useState by the time
 * the visitor navigates there.
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    const schedule = window.requestIdleCallback
      ? (cb: () => void) => window.requestIdleCallback(cb, { timeout: 3000 })
      : (cb: () => void) => window.setTimeout(cb, 1000)

    schedule(() => {
      const { load } = useRoomsData()
      const { preload } = useFloorSvgs()

      // fire and forget — failures fall back to the page fetching on mount
      load()
      preload()
    })
  })
})
